import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reducer'
})
export class ReducerPipe implements PipeTransform {

  transform(value: string, length: number, position: 'start' | 'end' | 'center' = 'center'): string {

    let result = value;
    const divider = '...';

    if (value.length > length) {
      switch (position) {
        case 'center':
          const around = length / 2;
          result = value.slice(0, around) + divider + value.slice(-around);
          break;
        case 'start':
          result = divider + value.slice(-length);
          break;
        case 'end':
          result = value.slice(length) + divider;
          break;
      }
    }

    return result;
  }

}
